import manifest from "./images.json";

/**
 * Responsive image helpers. `scripts/optimize-images.py` writes WebP renditions to
 * /images/w/<name>-<width>.webp and a manifest; we build `srcset` from it so every photo
 * downloads at the size it is displayed – and never as a 400 KB JPEG.
 */
const RE = /\/images\/([^/]+)\.(jpe?g|png)$/i;

export const imageEntry = (src) => {
  const m = RE.exec(src || "");
  return m ? { name: m[1], ...(manifest[m[1]] || {}) } : null;
};

export const srcSetFor = (src) => {
  const e = imageEntry(src);
  if (!e || !e.widths) return undefined;
  return e.widths.map((w) => `/images/w/${e.name}-${w}.webp ${w}w`).join(", ");
};

/** Smallest rendition – used for blurred placeholders and tiny thumbnails */
export const thumbFor = (src) => {
  const e = imageEntry(src);
  return e && e.widths ? `/images/w/${e.name}-${e.widths[0]}.webp` : src;
};

export const SIZES = {
  full: "100vw",
  wide: "(min-width: 1600px) 1540px, 100vw",
  half: "(min-width: 1280px) 620px, (min-width: 1024px) 50vw, 100vw",
  third: "(min-width: 1280px) 400px, (min-width: 640px) 50vw, 100vw",
  quarter: "(min-width: 1280px) 300px, (min-width: 640px) 33vw, 50vw",
  thumb: "120px",
};

/** Props for a plain <img>: src fallback + webp srcset + sizes */
export const imgProps = (src, sizes = SIZES.third) => {
  const ss = srcSetFor(src);
  return ss ? { src, srcSet: ss, sizes } : { src };
};
